import React from 'react';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import { Typography, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import Formsy from 'formsy-react';
import { FormsyDate, FormsyText } from 'formsy-material-ui/lib';
import globals from '../../../globals/communityGlobals';
import { refSetter } from '../../../utils/helpers';

import { textFieldStyle, multiLineText } from '../../../theme/AllocateBaseTheme';

const servicesLocale = globals.getArea('referralServices');
const errorsLocale = globals.getArea('error');

export const actionTypes = {
  create: 'CREATE',
  edit: 'EDIT',
};

class AddEditServiceForm extends React.Component {
  state = {
    canSubmit: false,
  };

  setRef = refSetter.bind(this);

  setEndDate = (endDate, maxDate) => {
    if (endDate) {
      return !moment(endDate).isSame(moment(maxDate), 'day') ? new Date(moment(endDate)) : undefined;
    }
    return undefined;
  };

  enableButton = () => {
    this.setState({
      canSubmit: true,
    });
  };

  disableButton = () => {
    this.setState({
      canSubmit: false,
    });
  };

  save = model => {
    const { submitAction, actionType } = this.props;
    if (actionType === actionTypes.create) {
      submitAction(model).then(() => this.form.reset());
    } else {
      submitAction(model);
    }
  };

  render() {
    const { actionType, name, serviceId, endDate } = this.props;

    const errorMessages = {
      maxLength: errorsLocale.getMsg('validationMaxLength', ['60']),
    };

    const isCreate = actionType === actionTypes.create;

    return (
      <div>
        <Box flexGrow={1} p={1}>
          <Typography variant="h2" component="h2" style={{ fontSize: '22px', fontWeight: '500' }}>
            {servicesLocale.getMsg(`${isCreate ? 'create' : 'edit'}Title`)}
          </Typography>
        </Box>
        <Box display="flex" flexDirection="column">
          <Formsy.Form
            ref={this.setRef('form')}
            onValidSubmit={this.submit}
            onValid={this.enableButton}
            onInvalid={this.disableButton}
            onSubmit={this.save}
          >
            <Box flexGrow={1} p={1}>
              <FormsyText
                name="name"
                required
                validations={{
                  maxLength: 60,
                }}
                validationErrors={errorMessages}
                value={name}
                multiLine
                rows={1}
                rowsMax={3}
                inputStyle={multiLineText.inputStyle}
                underlineStyle={multiLineText.underlineStyle}
                underlineFocusStyle={multiLineText.underlineFocusStyle}
                validationColor={textFieldStyle.validationColor}
                floatingLabelText={`${servicesLocale.getMsg('name')} *`}
              />
            </Box>
            <Box flexGrow={1} p={1}>
              <FormsyText
                name="serviceId"
                required
                validations={{
                  maxLength: 60,
                }}
                validationErrors={errorMessages}
                value={serviceId}
                // className="col-c12 cancellation-form"
                // floatingLabelStyle={textFieldStyle.floatingLabelStyle}
                // floatingLabelShrinkStyle={textFieldStyle.floatingLabelShrinkStyle}
                // style={multiLineText.style}
                multiLine
                rows={1}
                rowsMax={3}
                inputStyle={multiLineText.inputStyle}
                underlineStyle={multiLineText.underlineStyle}
                underlineFocusStyle={multiLineText.underlineFocusStyle}
                validationColor={textFieldStyle.validationColor}
                floatingLabelText={`${servicesLocale.getMsg('serviceId')} *`}
              />
            </Box>
            <Box flexGrow={1} p={1}>
              <FormsyDate
                className="date-picker"
                floatingLabelText="End Date"
                name="endDate"
                maxDate={new Date(9999, 11, 31, 0, 0, 0, 0)}
                minDate={isCreate ? globals.now.add(1, 'd').toDate() : globals.now.toDate()}
                value={this.setEndDate(endDate, new Date(9999, 11, 31, 0, 0, 0, 0))}
              />
            </Box>
            <Box flexGrow={1} p={1}>
              <RaisedButton
                primary
                label={servicesLocale.getMsg(`${isCreate ? 'create' : 'edit'}SubmitLabel`)}
                type="submit"
                disabled={!this.state.canSubmit}
              />
            </Box>
          </Formsy.Form>
        </Box>
      </div>
    );
  }
}

AddEditServiceForm.defaultProps = {
  name: '',
  serviceId: '',
  endDate: '',
  actionType: '',
};

AddEditServiceForm.propTypes = {
  name: PropTypes.string,
  serviceId: PropTypes.string,
  endDate: PropTypes.Date,
  actionType: PropTypes.string,
  submitAction: PropTypes.func.isRequired,
};

export default AddEditServiceForm;
